// DealsCommentsPage.tsx
import CommentsInput from 'components/Comments/CommentsInput'

const DealsCommentsPage = ({ contextFilters = ['deals'], taskSKs = [], expanded = false }) => {
  return (
    <CommentsInput
      taskSKs={taskSKs}
      contextFilters={contextFilters}
      expanded={expanded}
      context={'deals'}
      checklistItems={[]} // You can replace with real data
    />
  )
}

export default DealsCommentsPage
